(ns practitest.frontend.forms3.instance.rewind-run
  (:require [practitest.frontend.common.i18n :refer [get-translation format-translation]]
            [practitest.frontend.common.mixpanel :as mixpanel]
            [practitest.frontend.components.datepicker2 :as datepicker2]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.modal :as modal]
            [practitest.frontend.components2.buttons :as buttons]
            [re-frame.core :as re-frame]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.forms3.instance.events :as instance-events]
            [practitest.frontend.common-entities.metadata :as metadata]))


(def ^:private entity-type :instance)
(def metadata (get metadata/entities-metadata entity-type))
(def ^:private form-id (get metadata :form-id))

;; Rewind run modal
(defn show-rewind-run?
  []
  (let [options @(re-frame/subscribe [::subs/options])
        env (:backend-environment options)]
    (or (= "development" env)
        (= "stage" env))))

(re-frame/reg-event-db
  ::show-rewind-modal!
  (fn [db [_ run-id]]
    ;; Reset state as well
    (assoc-in db [:form-states2 form-id :modal-state] {:show-rewind-modal? true
                                                       :run-id run-id})))

(re-frame/reg-event-db
  ::hide-rewind-modal!
  (fn [db]
    (assoc-in db [:form-states2 form-id :modal-state :show-rewind-modal?] false)))

(re-frame/reg-sub
  ::modal-state
  (fn [db]
    (get-in db [:form-states2 form-id :modal-state])))

(re-frame/reg-sub
  ::show-rewind-modal?
  :<- [::modal-state]
  (fn [modal-state]
    (:show-rewind-modal? modal-state)))

(re-frame/reg-event-db
  ::set-rewind-date
  (fn [db [_ new-date]]
    (assoc-in db [:form-states2 form-id :modal-state :rewind-date] new-date)))

(defn rewind-run-menu-item [row]
  {:label (get-translation "instance.button.rewind-run" "Rewind Run")
   :icon icons/mux-redo
   :on-click (fn []
               (mixpanel/track "Grid Actions" {"Action" "Rewind Run"})
               (re-frame/dispatch [::show-rewind-modal! (:id row)]))})

(defn rewind-run-modal []
  (let [state @(re-frame/subscribe [::modal-state])
        date (:rewind-date state)
        run-id (:run-id state)]
    [modal/bootstrap-modal
     {:is-open? @(re-frame/subscribe [::show-rewind-modal?])
      :on-request-close #(re-frame/dispatch [::hide-rewind-modal!])
      :close-button? true
      :centered? true}
     (format-translation (get-translation "instance.rewind-modal-body"
                                          "Select a date to rewind run ID: %{id}")
                         {:id run-id})
     ;; Body
     [:div
      [datepicker2/date-picker-input
       {:value     date
        :time?     false
        :class     "m-input form-control"
        :on-change #(re-frame/dispatch [::set-rewind-date %])}]]
     ;; Footer
     [:div.m-button-group
      [buttons/button
       {:secondary? true
        :text (get-translation "generic.button.cancel"
                               "Cancel")
        :on-click #(re-frame/dispatch [::hide-rewind-modal!])}]
      [buttons/button
       {:primary? true
        :disabled? (nil? date)
        :on-click #(re-frame/dispatch [::instance-events/rewind-run run-id date [::hide-rewind-modal!]])
        :text (get-translation "instance.button.rewind" "Rewind")}]]]))
